import React, { useState, useEffect } from 'react';
import * as API from '../../http/api';
import { closelightbox } from '../../util/Functions';
import { Grid, TextField, Button, Typography, DialogActions, DialogContent, Dialog, DialogTitle } from "@mui/material";
import { initDay } from "../elements/DateRangePicker";
import { ModalStyle } from "../../util/Styles";

const R27Report = (props) => {
    const [zPos, setZPos] = useState(45)
    const [endDate, setEndDate] = useState(new Date().toJSON());
    const [startDate, setStartDate] = useState(initDay);

    useEffect(() => {
    }, []);

    const changeDayStart = (e) => {
        setStartDate(new Date(e.target.value).toISOString());
    };
    
      const changeDaysEnd = (e) => {
        setEndDate(new Date(e.target.value).toISOString());
    };

    const send = async () => {
        props.changeLoader(true);
        setZPos(-1)

        var data = {
            operation: "getReportClaims",
            data: {
                start: startDate,
                end: endDate,
                filters: {
                    page_number: 1,
                    results_per_page: 100
                }
            },
            agent_uuid: JSON.parse(localStorage.session).uuid
        };
    
        let request = await API.service('r27', data, props.pos, props.changeAlert, props.changeLoader, props.history);
        if (request.status === 200) {
            if (request.data.data.response === "OK") {
                setZPos(45);
                closelightbox();
                props.changeAlert(true, 'success', request.data.data.message);
            }
        }
        props.changeLoader(false);

    }

    return (
        <Dialog open={true} sx={{zIndex: zPos}} fullWidth>
            <ModalStyle property={String(false)}>
                <DialogTitle>
                    <Grid>
                        <Typography variant="h5" fontWeight={700}>Descargar reporte</Typography>
                        <Typography variant="subtitle1" style={{ paddingTop: -15 }}>
                            Indique el rango para la generación del Json
                        </Typography>
                    </Grid>
                </DialogTitle>

                <DialogContent>
                    <Grid container spacing={2} my={2}>
                        <Grid item xs={6}>
                            <TextField
                                label="Fecha de inicio"
                                onChange={changeDayStart.bind(this)}
                                value={startDate ? new Date(startDate).toJSON().substring(0, 10) : startDate}
                                type="date" variant="outlined" size='small' InputLabelProps={{ shrink: true }} fullWidth
                            />
                        </Grid>
                        <Grid item xs={6}>
                            <TextField
                                label="Fecha de cierre"
                                onChange={changeDaysEnd.bind(this)}
                                value={endDate ? new Date(endDate).toJSON().substring(0, 10) : endDate}
                                type="date" variant="outlined" size='small' InputLabelProps={{ shrink: true }} fullWidth
                            />
                        </Grid>
                    </Grid>

                </DialogContent>

                <DialogActions>    
                    <Button id='buttonCancel' variant="outlined" onClick={closelightbox} >Cancelar</Button>
                    <Button variant="contained" onClick={send}>Descargar</Button>
                </DialogActions>
            </ModalStyle>
        </Dialog>
    );
}
export default R27Report;